module.exports = __webpack_public_path__ + "static/img/history09.eaea54a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history09.jpg
// module id = 9Gf6
// module chunks = 1